var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    fill: "none",
    height: 19,
    role: "img",
    viewBox: "0 0 16 19",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6538 1.1558C12.2359 0.736002 11.668 0.5 11.0757 0.5H4.92516C4.33293 0.5 3.7651 0.735926 3.34724 1.1556L0.648769 3.86581C0.233272 4.28311 -0.00660415 4.84855 0.022718 5.4367C0.489714 14.8038 8 18.5 8 18.5C8 18.5 15.8761 14.6238 15.9986 4.75049C16.0004 4.60331 15.9417 4.45883 15.8379 4.35451L12.6538 1.1558Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2324 5.67574C11.5496 5.94216 11.5907 6.41525 11.3243 6.73241L6.55002 12.4161L4.17574 9.58955C3.90932 9.27239 3.95046 8.7993 4.26762 8.53288C4.58479 8.26646 5.05788 8.3076 5.3243 8.62477L6.55002 10.084L10.1757 5.76762C10.4422 5.45046 10.9152 5.40932 11.2324 5.67574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkShieldIcon);
export default __webpack_public_path__ + "static/media/checkmark-shield-icon.4118b213be42a67f0c0b125480fa1c29.svg";
export { ForwardRef as ReactComponent };